import { createContext } from 'react';

const prefContext = createContext();

export default prefContext;
